import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { i18n } from '@lingui/core';

const useIconStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
        ...theme.mixins.flex.justifyContentCenter,

        height: '100%',
    },

    icon: {
        '&, & .MuiSvgIcon-root, & .MuiIcon-root': {
            fontSize: '18px',
            height: '18px',
            lineHeight: '18px',
        },

        '&.clickable': {
            cursor: 'pointer',
        },

        '&:focus': {
            outline: 'none',
        },
    },
}));

function DataTableIcons(props) {
    const { icons, data } = props;
    const classes = useIconStyles(props);

    return (
        <div className={classes.root}>
            {icons?.map((iconCfg, idx) => {
                /* eslint-disable react/no-array-index-key */
                const { getIcon, clickHandler, getTooltip } = iconCfg;
                const clickable = typeof clickHandler === 'function';
                let { icon } = iconCfg;

                if (typeof getIcon === 'function') {
                    icon = getIcon(data, iconCfg);
                }

                const tooltip = (getTooltip || defaultTooltipGetter)(data, iconCfg);
                const tooltipProps = {};

                if (tooltip) {
                    tooltipProps.title = i18n._(tooltip);
                }

                const onClick = (e) => {
                    if (clickable) clickHandler(data, iconCfg, e);
                };

                return (
                    <div
                        key={idx}
                        className={clsx(classes.icon, { clickable })}
                        onClick={onClick}
                        onKeyDown={(e) => e.keyCode === 13 && onClick(e)}
                        role={clickable ? 'button' : 'image'}
                        tabIndex={-1 * idx}
                        {...tooltipProps}
                    >
                        {icon}
                    </div>
                );
            })}
        </div>
    );
}

DataTableIcons.propTypes = {
    icons: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
    data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export function iconRenderer(row, column) {
    return <DataTableIcons icons={column.icons} data={row} />;
}

function defaultTooltipGetter(_row, iconCfg) {
    return iconCfg.tooltip;
}
